
(() => {
  let swiperElem
  let prevEl
  let nextEl

  function run () {
    swiperElem = document.querySelector('.product-medias__main .swiper-container.swiper-container-initialized')

    if (swiperElem?.swiper) {
      prevEl = swiperElem.querySelector('.swiper-button-prev')
      prevEl
        .addEventListener('click', () => {
          swiperElem.swiper.slidePrev()
          update()
        })

      nextEl = swiperElem.querySelector('.swiper-button-next')
      nextEl
        .addEventListener('click', () => {
          swiperElem.swiper.slideNext()
          update()
        })

      update()
    } else {
      setTimeout(run, 2500)
    }
  }

  function update () {
    // const active = swiperElem.swiper.activeIndex
    // prevEl.classList.toggle('active', active > 0)
    // nextEl.classList.toggle('active', active < swiperElem.swiper.slides.length - 1)
  }

  run()
})()
